//查询我的商铺申请状态
const getBusinessCircleStatusUrl = `/gateway/hc-serve/miniapi/trading/checkStatus`;
//获取我的商铺信息
const getMyBusinessUrl = `/gateway/hc-serve/miniapi/trading/getMyMallShop`;
//提交商圈申请
const postApplyUrl = `/gateway/hc-serve/miniapi/trading/apply`;
//个人信息
const userInfoUrl = `/gateway/hc-mini/user/mini/user-info`;
//证件类型下拉框列表查询
const getInitInfoUrl = `/gateway/blade-system/userManagement/getInitInfo`;
//订单列表
const getOrderListUrl = `/gateway/hc-serve/miniapi/trading/getGoodsOrderInfo`;
//订单详情
const getOrderIdUrl = `/gateway/hc-serve/miniapi/trading/getGoodsOrderDetailsById`;
// 获取全部商户信息
const getShopInfoListUrl = `/gateway/hc-serve/manageapi/pointsMallShop/getShopInfoList`;
// 根据商圈id获取详情
const detailByIdUrl = `/gateway/hc-serve/manageapi/pointsMallShop/detailById`;
// 获取商品列表
const getShopGoodsListUrl = ` /gateway/hc-serve/miniapi/pointsMall/list`;
//获取区级联动接口
const areaLinkUrl = "gateway/hc-space/space/getSpaceLinkList";
//运营位列表
const getBannerListUrl = `/gateway/hc-neighbour/topic/getTopicList`;
export {
  getBannerListUrl,
  getBusinessCircleStatusUrl,
  getMyBusinessUrl,
  postApplyUrl,
  userInfoUrl,
  getInitInfoUrl,
  getOrderListUrl,
  getOrderIdUrl,
  getShopInfoListUrl,
  detailByIdUrl,
  getShopGoodsListUrl,
  areaLinkUrl,
};
